import {Routes} from '@angular/router';
import {SigninComponent} from './auth/signin/signin.component';
import {DossierComponent} from './dossier/dossier.component';
import {VisioComponent} from './visio/visio.component';
import {AuthGuard} from './guard/auth.guard';
import {VisioGuard} from './guard/visio.guard';
import {AutologComponent} from './autolog/autolog.component';
import {PhotoComponent} from './photo/photo.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: 'auth/signin',
        component: SigninComponent
      },
      {
        path: 'a',
        component: AutologComponent
      },      {
        path: 'photo',
        component: PhotoComponent
      },
      {
        path: '',
        canActivate: [AuthGuard],
        children: [
          {
            path: 'dossier',
            component: DossierComponent
          },
          {
            path: 'visio',
            component: VisioComponent,
            canActivate: [VisioGuard]
          },
          {
            path: '**',
            redirectTo: '/dossier'
          }
        ]
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/dossier'
  }
];




// WEBPACK FOOTER //
// ./src/app/routes.ts